import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import { FaCopy, FaDownload, FaExpand } from 'react-icons/fa';
import {
  getFgtnEpisodeUrl,
  getFgtnQrPath,
} from '../../utils/fgtn';
import { downloadLabeledFgtnQrPng, FGTN_QR_PNG_SIZE } from '../../utils/fgtnQrCard';
import FgtnQrArt from './FgtnQrArt';

const PREVIEW_QR_SIZE = 240;

export default function FgtnQrBlock({ episodeNumber, title }) {
  const qrCanvasRef = useRef(null);
  const [copied, setCopied] = useState(false);
  const url = getFgtnEpisodeUrl(episodeNumber);

  const downloadPng = () => {
    downloadLabeledFgtnQrPng({
      qrCanvas: qrCanvasRef.current,
      episodeNumber,
    });
  };

  const copyUrl = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1600);
    } catch (err) {
      console.error('Could not copy FGTN URL', err);
    }
  };

  return (
    <aside className="fgtn-card fgtn-qr-card">
      <h2>On-air QR</h2>
      <FgtnQrArt
        episodeNumber={episodeNumber}
        url={url}
        size={PREVIEW_QR_SIZE}
        title={title}
      />
      <QRCodeCanvas
        ref={qrCanvasRef}
        className="fgtn-qr-download-source"
        value={url}
        size={FGTN_QR_PNG_SIZE}
        level="H"
        marginSize={2}
        bgColor="#ffffff"
        fgColor="#111111"
      />
      <p className="fgtn-qr-url">{url}</p>
      <div className="fgtn-actions">
        <button type="button" className="fgtn-btn" onClick={downloadPng}>
          <FaDownload /> Download PNG
        </button>
        <Link className="fgtn-btn-secondary" to={getFgtnQrPath(episodeNumber)} target="_blank" rel="noreferrer">
          <FaExpand /> Full-screen QR
        </Link>
        <button type="button" className="fgtn-btn-secondary" onClick={copyUrl}>
          <FaCopy /> {copied ? 'Copied' : 'Copy page URL'}
        </button>
      </div>
    </aside>
  );
}
